import { getUser } from "../services/Auth";
import api from "./api";

export const listarProdutos = async (page = 1) => {
  try {
    let usuario = await getUser();
    const produtos = await api.get(
      `estabelecimentos/${usuario.estabelecimento._id}/produtos?page=${page}`,
    );
    return produtos.data;
  } catch (error) {
    throw error;
  }
};

export const listarProdutosPorCategoria = async (categoria_id, page = 1) => {
  try {
    const produtos = await api.get(`categorias/${categoria_id}/produtos?page=${page}`);
    return produtos.data;
  } catch (error) {
    throw error;
  }
};

export const CadastrarProduto = async (data) => {
  try {
    const produtos = await api.post(`/produtos`, data);
    return produtos.data;
  } catch (error) {
    throw error;
  }
};

export const EditarProduto = async (data, id) => {
  try {
    const produtos = await api.put(`/produtos/${id}`, data);
    return produtos.data;
  } catch (error) {
    throw error;
  }
};

export const DeletarProduto = async (id) => {
  try {
    const produtos = await api.delete(`/produtos/${id}`);
    return produtos.data;
  } catch (error) {
    throw error;
  }
};
